import styled, {css} from "styled-components"

import workOSImg from "@irati/ui/images/workOS-integrations.svg"
import workOSWarningImg from "@irati/ui/images/workOS-integrations-warning.svg"

const style = css`
  height: 50%;
  width: 50%;
`
export const StyledImg = styled.img.attrs({
  src: workOSImg,
  alt: "WorkOS Integrations img"
})`${style}`

export const StyledWarningImg = styled.img.attrs({
  src: workOSWarningImg,
  alt: "WorkOS Integrations expired link img"
})`${style}`
